
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in/[[...index]]",
      function () {
        return require("private-next-pages/sign-in/[[...index]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-in/[[...index]]"])
      });
    }
  